class CollectionCarousels extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    this.windowWidth = window.innerWidth
    this.windowHeight = window.innerHeight
    this.resizeTimeout = null

    window.addEventListener('resize', this.onResize.bind(this))
  }

  onResize () {
    // Clear existing timeout to throttle resize events
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout)
    }

    // Throttle resize handling to prevent excessive recalculations
    this.resizeTimeout = setTimeout(() => {
      if (
        window.innerWidth === this.windowWidth &&
        window.innerHeight === this.windowHeight
      ) {
        return
      }

      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight

      // Dispatch custom event for carousel components to handle resize
      window.dispatchEvent(
        new CustomEvent('carouselResize', {
          detail: {
            windowWidth: this.windowWidth,
            windowHeight: this.windowHeight,
          },
        }),
      )
    }, 150) // 150ms throttle delay
  }
}

if (!customElements.get('collection-page-carousels')) {
  customElements.define('collection-page-carousels', CollectionCarousels)
}
